import { Site } from './site';
import { SKU } from './sku';
import { Location } from './washhub';
import { Customer } from './user';

export enum Status {
  OPEN, // this means NEW in the BE
  PACKED,
  DELIVERED,
  RETURNED,
  WASHED,
  DRY,
  UNUSED,
  READY,
  MISSING,
  LOST,
  DECOMMISSIONED,
  DAMAGED,
  CLOSE,
  PENDING_COUNT,
  EMPTY_BIN,
  CUSTOMER_REQUEST,
  REJECTED,
  PENDING_INVOICE,
  TRANSFER_OUT,
  TRANSFER_IN,
  UNPACK,
  RECOVERED,
  RECONCILED_MISSING,
  RECONCILED_FOUND,
}
export enum DateStatus {
  TODAY,
  TOMORROW,
  OVERDUE,
  FUTURE,
}

export type Item = {
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  sku: SKU;
  status: Status;
  type: string;
  quantityPerCase: number;
  size: number;
  rfid: string;
  washHub: Location;
  washHubCode: string;
  currentPackage: string;
  lastScanAt: string;
  currentVenue?: Site;
  packageId?: string;
  qrCode?: string;
};

export type ItemCount = {
  name: string;
  _id: string;
  breakdown?: {
    [key: string]: number;
  };
  total: number;
};

export type Case = {
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  sku: SKU;
  status: Status;
  washHub: Location;
  currentPackage?: string;
  currentVenue?: Site;
};

export type Scan = {
  _id: string;
  caseCount: number;
  createdAt: Date;
  itemCount: number;
  scanPerformedBy: Partial<Customer>;
  status: Status;
  updatedAt: Date;
  washHub: string;
  isEPC?: boolean;
  site?: Array<any>;
  itemSku?: Array<SKU>;
  performedAt?: Date;
  scanId?: string;
};
